module.exports = __webpack_public_path__ + "img/yuewangmu.317deb91.jpg";